// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__7SQsl","summary":"CartItem_summary__lJPWh","price":"CartItem_price__XIP3s","amount":"CartItem_amount__IKzrF","actions":"CartItem_actions__qOxLG"};